import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import Input from '../ui/Input';
import { Edit, Trash2 } from 'lucide-react';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { createGroup, deleteGroup, getGroups, updateGroup } from '../../services/api';
import { toast } from 'react-toastify';

const GroupManagement = ({ onAddGroup, onEditGroup, onDeleteGroup }) => {
  const [newGroupName, setNewGroupName] = useState({
    name: '',
  });
  const [editingGroup, setEditingGroup] = useState(null);
  const [deletingGroupId, setDeletingGroupId] = useState(null);
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [groups, setGroups] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {  
      fetchGroups();
  }, []); // Fetch data whenever issuesPage changes

  const fetchGroups = async () => {
    try {
        const response = await getGroups();
        setGroups(response.groups);

        // toast.success('Groups Loaded successfully!');

    } catch (err) {
        setError(err.message || 'Failed to fetch group data');
        toast.error(err.message || 'Failed to fetch group data');
    }
  };

  // const handleAddGroup = (e) => {
  //   e.preventDefault();
  //   setError('');
  //   setSuccess('');

  //   if (newGroupName.trim()) {
  //     onAddGroup(newGroupName.trim());
  //     setNewGroupName('');
  //   }
  // };

  const handleAddGroup = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
        const response = await createGroup(newGroupName);
        setSuccess('Group created successfully!');
        // console.log('Issue registered:', response);
        toast.success('Group created successfully!');
        setNewGroupName({
          name: '',
        });
        // navigate('/groups'); // Redirect to the issues list page
        fetchGroups();
        // window.location.href =  '/itemgroups'
    } catch (err) {
        setError(err.message || 'Failed to create Group');
        toast.error(err.message || 'Failed to create Group');
    }
  };

  // const handleEditGroup = (e) => {
  //   e.preventDefault();
  //   if (editingGroup && editingGroup.name.trim()) {
  //     onEditGroup(editingGroup.id, editingGroup.name.trim());
  //     setEditingGroup(null);
  //   }
  // };

  const handleEditGroup = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
        const response = await updateGroup(editingGroup._id, editingGroup);
        setSuccess('Group updated successfully!');
        toast.success('Group updated successfully!');
        setEditingGroup(null);
        fetchGroups();
        // console.log('Issue updated:', response);
        // navigate('/issues'); // Redirect to the issues list page
    } catch (err) {
        setError(err.message || 'Failed to update group');
        toast.error(err.message || 'Failed to update group');
    }
  };


return (
  <>
    <div className="flex items-center justify-between mb-3">
      <h1 className="text-xl font-bold">Item Groups</h1>
      <form onSubmit={handleAddGroup} className="">
        <div className="flex items-center">
          <Input
            type="text"
            value={newGroupName.name}
            onChange={(e) => setNewGroupName({ ...newGroupName, name: e.target.value })}
            placeholder="New group name"
            className="flex-grow w-64 p-2 mr-1 rounded focus:outline-none"
          />
          <Button type="submit">Add Group</Button>
        </div>
      </form>
    </div>

    {/* <div className="bg-white dark:bg-gray-900 shadow-md rounded-lg px-3 py-2 mb-3">
      <form onSubmit={handleAddGroup} className="flex items-center justify-between flex-col md:flex-row">
          <Input
            type="text"
            value={newGroupName.name}
            // onChange={(e) => setNewGroupName(e.target.value)}
            onChange={(e) => setNewGroupName({ ...newGroupName, name: e.target.value })}
            placeholder="New group name"
            className="flex-grow"
          />
          <Button type="submit">Add Group</Button>
      </form>
    </div> */}

    <div className="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 mb-6">
      {/* <h2 className="text-2xl font-bold mb-4">Manage Groups</h2> */}
      {/* <form onSubmit={handleAddGroup} className="mb-4">
        <div className="flex items-center space-x-2">
          <Input
            type="text"
            value={newGroupName.name}
            // onChange={(e) => setNewGroupName(e.target.value)}
            onChange={(e) => setNewGroupName({ ...newGroupName, name: e.target.value })}
            placeholder="New group name"
            className="flex-grow"
          />
          <Button type="submit">Add Group</Button>
        </div>
      </form> */}
      <div className="space-y-2">
        {groups.map((group) => (
          <div key={group._id} className="flex items-center justify-between bg-white dark:bg-gray-900 p-2 rounded">
            {editingGroup && editingGroup._id === group._id ? (
              <form onSubmit={handleEditGroup} className="flex-grow flex items-center space-x-2">
                <Input
                  type="text"
                  value={editingGroup.name}
                  onChange={(e) => setEditingGroup({ ...editingGroup, name: e.target.value })}
                  className="flex-grow"
                />
                <Button type="submit" size="sm">Save</Button>
                <Button type="button" size="sm" variant="outline" onClick={() => setEditingGroup(null)}>Cancel</Button>
              </form>
            ) : (
              <>
                <span>{group.name}</span>
                <div>
                  <Button size="sm" variant="outline" onClick={() => setEditingGroup(group)} className="mr-2">
                    <Edit size={16} />
                  </Button>
                  <Button size="sm" variant="destructive" onClick={() => setDeletingGroupId(group._id)}>
                    <Trash2 size={16} />
                  </Button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      {deletingGroupId && (
        <DeleteConfirmationModal
          method={deleteGroup}
          itemId={deletingGroupId}
          onClose={() => setDeletingGroupId(null)}
          onConfirm={() => {
            onDeleteGroup(deletingGroupId);
            setDeletingGroupId(null);
            fetchGroups();
          }}
          message="Are you sure you want to delete this group? This action cannot be undone."
        />
      )}
    </div>
  </>
  );
};

export default GroupManagement;